export const CLEAR_BILLING_INFO = 'CLEAR_BILLING_INFO';
export const UPDATE_BILLING_ADDRESS = 'UPDATE_BILLING_ADDRESS';
export const UPDATE_BILLING_ADDRESS_FIELD = 'UPDATE_BILLING_ADDRESS_FIELD';
export const UPDATE_BILLING_AS_SHIPPING = 'UPDATE_BILLING_AS_SHIPPING';
export const UPDATE_BILLING_SAVED_ADDRESS_FIELD = 'UPDATE_BILLING_SAVED_ADDRESS_FIELD';
export const UPDATE_BILLING_TYPE_SAME = 'UPDATE_BILLING_TYPE_SAME';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const UPDATE_CUSTOMER_ACCEPT_MARKETING = 'UPDATE_CUSTOMER_ACCEPT_MARKETING';
export const UPDATE_CUSTOMER_EMAIL = 'UPDATE_CUSTOMER_EMAIL';
export const UPDATE_CUSTOMER_FIELD = 'UPDATE_CUSTOMER_FIELD';
export const UPDATE_SHIPPING_ADDRESS = 'UPDATE_SHIPPING_ADDRESS';
export const UPDATE_SHIPPING_ADDRESS_FIELD = 'UPDATE_SHIPPING_ADDRESS_FIELD';
export const UPDATE_SHIPPING_SAVED_ADDRESS_FIELD = 'UPDATE_SHIPPING_SAVED_ADDRESS_FIELD';
